import { render } from "./RmsForm.vue?vue&type=template&id=19180c99&scoped=true"
import script from "./RmsForm.vue?vue&type=script&lang=js"
export * from "./RmsForm.vue?vue&type=script&lang=js"

import "./RmsForm.vue?vue&type=style&index=0&id=19180c99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19180c99"]])

export default __exports__